<template>
    <form-row title="Inspection Due" section_id="inspection">
        <div class="mt-2 sm:-mt-4">
            <input-date
                label="Date"
                name="inspection_date"
                v-model="inspection_date"
                @entered="dateEntered"
                :read_only="read_only"
            />
        </div>

        <div class="w-24 sm:pl-6 mt-2 sm:-mt-4">
            <input-text
                label="Period"
                name="inspection_period"
                v-model="inspection_period"
                placeholder="Days"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        inspection: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            inspection_date: this.inspection.inspection_date,
            inspection_period: this.inspection.inspection_period,
        }
    },

    computed: {
        contract_acceptance_date() {
            return store.state.contract_acceptance_date;
        },
        inspection_date_from_period() {
            if (! this.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(this.contract_acceptance_date) && this.inspection_period) {
                return dayjs(this.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.inspection_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.inspection_period = null;
        },
    },

    watch: {
        inspection_date_from_period(val) {
            if (val) {
                this.inspection_date = val;
            }
        },
    },
}
</script>
